module.exports = {
  siteTitle: 'Danniel Hansel', // Navigation and Site Title
  siteTitleAlt: 'The personal website of Danniel Hansel', // Alternative Site title for SEO
  siteTitleShort: 'dannielhansel', // short_name for manifest
  siteUrl: process.env.ROOT_URL || 'https://dannielhansel.com', // Domain of your site. No trailing slash!
  lang: 'en', // Language Tag on <html> element
  pathPrefix: '/',
  siteLogo: 'images/logo.svg', // Used for SEO and manifest, path to your image you placed in the 'static' folder
  author: 'Danniel Hansel', // Author for schemaORGJSONLD
  siteDescription:
    `Hi, I'm Danniel Hansel. I'm a Software Engineer based in Dallas, Texas. I write blogs about my thoughts, life experiences, solving problems as well as all technology related things.`,
  minibio: `
    <strong>Danniel Hansel</strong> is a software engineer graduated from The University of Texas 
		at Arlington. He's based in Dallas and loves to work and collaborate on side projects. He's also an outdoor enthusiast and loves fishing, playing soccer and golf.
		Outside of those, he writes about his experience on technology related things.
  `,
  keywords: [
      'Software Engineer',
      'React Enthusiast',
      'Freelancer',
      "Javascript Enthusiast",
      "Full Stack Developer",
      "Front End Developer",
  ],
  organization: 'Danniel Hansel Tech LLC',
  siteFBAppID: '596438108319069', // Facebook App ID - Optional
  userTwitter: '@dehanz13', // Twitter Username
  ogSiteName: 'Danniel Hansel', // Facebook Site Name
  ogLanguage: 'en_US',

  // Manifest and Progress color
  themeColor: '#4147DC',
  backgroundColor: '#231C42',

  // Social component
  twitter: 'https://twitter.com/dehanz13/',
  twitterHandle: '@dehanz13',
  twitterDescription: `Follow me on Twitter and lets connect!`,
  github: 'https://github.com/dehanz13/',
  linkedin: 'https://www.linkedin.com/in/dannielhansel/',
  buymeacoffee: 'https://www.buymeacoffee.com/dannielhansel',

}